/**
 * @fileoverview POST handler for the "/engagement/content_blocks(/:id)" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { engagementContentBlocksIdCacheKeys } from "./constants";
import type { ContentBlockPayload, ContentBlockResult, ContentBlockUpsertError } from "./types";

export const postEngagementContentBlocksId = reactQueryMutationAdapter(
  engagementContentBlocksIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<ContentBlockUpsertError>()(
    (contentBlock: ContentBlockPayload): Promise<ContentBlockResult> => {
      return fetch(
        `/engagement/content_blocks${contentBlock.id ? `/${contentBlock.id}` : ""}`,
        "POST",
        contentBlock,
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
